import * as React from "react";

import {FontAwesomeIcon}    from "../../../../../node_modules/@fortawesome/react-fontawesome";
import {faEye, faEyeSlash}  from "../../../../../node_modules/@fortawesome/free-solid-svg-icons";

import "./floating-input.scss"

export const FloatingInput = ({
    classContainer="",
    classLabel="",
    props=null,
    required=false,
    textLabel="",
    type="text"
}) => {
    const inputRef = React.useRef(null)
    const [showPassword, setShowPassword] = React.useState(false)
    const ilk = (type === "password" && showPassword) ? "text" : type
    const classNameRequired = required ? "required" : "required hidden"

    React.useEffect(() => {
        const input = inputRef.current

        if(input && input.value) {
            input.classList.add('auto-fill')
        }

        const handleInput = () => {
            if(input.value) {
                input.classList.add('auto-fill')
                return
            }
            input.classList.remove('auto-fill')
        }

        input.addEventListener('input', handleInput)

        return () => {
            input.removeEventListener('input', handleInput)
        }
    }, [])

    return (
        <div className={`floating-input-dznts0 ${classContainer}`}>
            <input
                ref={inputRef}
                type={ilk} 
                {...props}
                required
            />
            <label className={classLabel} xd-qa-type="label" xd-qa-name={textLabel}>{textLabel}</label>
            {
                type === "password" &&
                <div className="show-hide" onClick={() => setShowPassword(!showPassword)} >
                    <FontAwesomeIcon
                        className={"icon"}
                        icon={showPassword ? faEyeSlash : faEye}
                        xd-qa-type="icon"
                        xd-qa-name={showPassword ? "hide" : "show"}
                    />
                </div>
            }
            <div className={classNameRequired}>*</div>
        </div>
    )
}